import React from 'react';
import {connect} from 'react-redux';
import {Grid, Image} from 'semantic-ui-react';

import SecurityImg from '../../assets/quick/security.svg';
import Button from '../../components/forms/button';

export class PaymentFailedPage extends React.Component {
	onClickButton = (e) => {
		this.props.history.push('/');
	}

	render () {

		return (
			<Grid centered stackable className='with-padding'>
				<Grid.Row>
					<Grid.Column>
						<h2 className='center'>Your Payment Was Declined</h2>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<Image src={ SecurityImg } className='center' />
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<h4 className='center'>
							{ this.props.meta ? this.props.meta.message : 'We apologize but we could not process your payment at this time.' }
						</h4>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<Button tertiary fluid size='big' onClick={this.onClickButton}>Take me back</Button>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.callbackPaymentReducer.meta
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
	};
}

export default connect( mapsStateToProps, mapsDispatchToProps )(PaymentFailedPage);



// WEBPACK FOOTER //
// ./src/containers/callback-payment-page/payment-failed-page.js